<template>
  <div class="page-wrapper">
    <div v-if="showManagerLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
    <b-form class="p-3 row align-items-center">
        <b-form-group label="Start Date" class="text-left col-sm-4 start-date">
            <b-form-group>
                <b-form-datepicker
                    v-model="form.date_s"
                    size="sm"
                    required/>
            </b-form-group>
        </b-form-group>
        <b-form-group label="End Date" class="text-left col-sm-4 end-date">
            <b-form-group class="date_picker_add">
                <b-form-datepicker 
                    v-model="form.date_e"
                    size="sm"
                    required/>
            </b-form-group>
        </b-form-group>
        <b-button-group class="w-100 col-sm-4 filter-btn">
            <b-button variant="outline-primary" @click="applyFilter">Filter</b-button>
            <download-csv v-if="this.totalSentProspect"
                style="margin-left: 10px;"
                :data="this.getCSVData()"
                :name="this.getFileName()"
                :fields="managerFields"
                :labels="managerLabels"
                >
                <b-button  variant="outline-primary" >Export Prospects Sent</b-button>
            </download-csv>
        </b-button-group>
    </b-form>
    <div ref="managerForm" class="w-80 mx-auto custom-form">

        
        
        <div class="form-title">
            <b-button variant="outline-primary" @click="AddManagerModalEvent();">Add a Manager</b-button>
        </div>

        <b-modal id="AddManagerModal" hide-footer>
			<template v-slot:modal-title>
				Add Manager
			</template>
            <b-form class="row manager-form">
                <b-form-group  class="my-1 col-6">
                    <b-form-input
                        type="text"
                        placeholder="First Name"
                        v-model="form.First"
                        required />
                </b-form-group>
                <b-form-group class="my-1 col-6">
                    <b-form-input
                        type="text"
                        placeholder="Last Name"
                        v-model="form.Last"/>
                </b-form-group>
                <b-form-group class="my-1 col-6">
                    <b-form-input
                        type="email"
                        placeholder="Email"
                        v-model="form.Email"/>
                </b-form-group>
                <b-form-group class="my-1 col-6">
                    <b-form-input
                        type="tel"
                        placeholder="(xxx) xxx-xxxx"
                        v-mask="'(###) ###-####'"
                        v-model="form.Number"
                        required />
                </b-form-group>
                <!-- <b-form-group  class="my-1 col-12">
                    <b-form-input
                        type="text"
                        placeholder="Office"
                        v-model="form.Office"
                        :disabled="isDisableOffice"
                        required
                        />
                </b-form-group> -->
            </b-form>
            <b-button-group class="px-3 w-100 submit-form-btn">
                <b-button variant="outline-primary" @click="saveMangerInfo">Save</b-button>
            </b-button-group>
        </b-modal>
    </div>
    <b-table-simple bordered striped responsive hover class="mx-auto text-center middle-grid-sc">
        <b-thead head-variant="light">
            <b-tr class="text-center">
                <b-th><span>Total Prospects Sent</span></b-th>
                <b-th><span>Total Prospects Reviewed</span></b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr>
                <b-td style="width: 150px;">{{totalSentProspect}}</b-td>
                <b-td style="width: 150px;">{{totalReviewdProspect}}</b-td>
            </b-tr>
            
            
        </b-tbody>
    </b-table-simple>
    
     <b-table :items="getManagerList" :fields="fields" striped responsive="sm">
      <template #cell(Prospect)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2 showProsBtn">
          Show Prospects
        </b-button>
      </template>

      <template #cell(Action)="row">
        <b-button style="width: 50%;float: left;" variant="outline" @click="editManagerDetail(row.item)">
            <v-icon class="text-blue" name="edit" />
        </b-button>
        <b-button style="width: 50%;float: left;" variant="outline" @click="removeManger(row.item)">
            <v-icon class="text-blue" name="times" />
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
            <b-table-simple bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
                <b-thead v-if="row.item.managerProps.length > 0">
                    <b-tr>
                        <b-th>Date</b-th>
                        <b-th>First Name</b-th>
                        <b-th>Last Name</b-th>
                        <b-th>Email</b-th>
                        <b-th>Phone Number</b-th>
                        <b-th>Postal Code</b-th>
                        <b-th>Status</b-th>
                        <b-th>Rating</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr
                        :key="mgr.MgrID"
                        class="text-left position-relative"
                        v-for="mgr in row.item.managerProps"
                        @click="singleManagerProspectClick(mgr)"
                    >
                        <b-td style="width: 150px;">{{$parseDate(mgr.SentOn)}}</b-td>
                        <b-td style="width: 150px;">{{mgr.First}}</b-td>
                        <b-td style="width: 150px;">{{mgr.Last}}</b-td>
                        <b-td style="width: 150px;">{{mgr.Email}}</b-td>
                        <b-td style="width: 150px;">{{mgr.Number}}</b-td>
                        <b-td style="width: 150px;">{{mgr.Zip}}</b-td>
                        <b-td style="width: 150px;">{{mgr.Status}}</b-td>
                        <b-td style="width: 150px;">{{mgr.rating}}</b-td>
                    </b-tr>
                    
                    
                </b-tbody>
            </b-table-simple>
        </b-card>
      </template>
    </b-table>
  </div>
  
</template>



<script>
	import { db } from 'src/db'
	import { mapState } from 'vuex'

	export default {
		name: "Managers",
		computed: {
            getManagerList() {
                this.makeTotalCountZero()
				const managerList = [];
				if (this.user.Managers) {
                    // managerList = this.user.Managers;
                    this.user.Managers.forEach(val => managerList.push(Object.assign({}, val)));
                }
                managerList.forEach(element => {
                    let managerProps = [];
                    let reviewdCount = 0;
                    const offices = this.user.Offices.filter(o => o.MgrID === element.MgrID);
                    const officeNames = offices.map(o => o.OfficeName).join(', ');
                    for(let pro of this.prospects) {
                        if (pro.hasOwnProperty('SentToManager')) {
                            let sentManager = pro.SentToManager;
                            let sm = sentManager.find(sm => sm.Manager == element.MgrID);
                            if (sm) {
                                if (this.form.s_date && this.form.e_date) {
                                    let convertedSDate = new Date(this.form.s_date).setHours(0,0,0,0);
                                    let convertedEDate = new Date(this.form.e_date).setHours(23,59,59,999);
                                    if ((sm.SentOn >= convertedSDate && sm.SentOn <= convertedEDate)) {
                                        managerProps.push({
                                            SentOn:sm.SentOn,
                                            First:pro.First,
                                            Last:pro.Last,
                                            Email:pro.Email,
                                            Number:pro.Number,
                                            Zip:pro.Zip,
                                            rating:sm.Rating,
                                            id:pro.id,
                                            Source:pro.Source,
                                            Notes:sm.Notes,
                                            Office:officeNames,
                                            MName:element.First +' '+element.Last,
                                            MEmail:element.Email,
                                            MNumber:element.Number,
                                            ReviewedOn:sm.ReviewedOn,
                                            Rating:sm.Rating,
                                            Status:pro.Status,
                                            MNote:sm.MgrNotes
                                        });
                                        if (sm.ReviewedOn && sm.Rating) {
                                            reviewdCount++;
                                        }
                                    }
                                   
                                }
                                
                            }
                        }
                    }
                    element.managerProps = managerProps;
                    element.ProspectsSent = managerProps.length;
                    element.ProspectsReviewed = reviewdCount;
                    element.Office = officeNames.toString();
                    this.calculateProspectCount(element.ProspectsSent,reviewdCount,managerProps);
                });
				return managerList;
			},
            
			...mapState('firebase', ['user', 'prospects', 'campaigns','emails'])
		},
		methods: {
            calculateProspectCount(scount,rcount,manProsp) {
                if (scount) {
                    this.prospectMangerCSVList = this.prospectMangerCSVList.concat(manProsp)
                }
                this.totalSentProspect = this.totalSentProspect + scount;
                this.totalReviewdProspect = this.totalReviewdProspect + rcount;
            },
            makeTotalCountZero() {
                this.totalSentProspect = 0;
                this.totalReviewdProspect = 0;
                this.prospectMangerCSVList = [];
                this.downloadCount = 0;
            },
            isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
            },
            applyFilter() {
                this.totalSentProspect = 0;
                this.totalReviewdProspect = 0;
                this.form.s_date = this.form.date_s;
                this.form.e_date = this.form.date_e;
            },
            
            async emitToProspInfo(task) {
                let convo = this.$store.state.firebase.convos.find(convo => convo.ClientNumber == task.singleProsp.Number);
                
                if (!convo) {
					convo = await db.collection('Conversations').add({
						ClientNumber: task.singleProsp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: task.singleProsp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id);
                if (this.emails && this.emails.length) {
                    let mid = this.getEmailConvoID(task.singleProsp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
                    // this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(task.singleProsp.id));
                }
				this.$emit('open','prosp');
            },
            getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
            singleManagerRowClick(singleManager) {
                //eslint-disable-next-line
                console.log(singleManager);
            },
            saveMangerInfo() {
                // if (this.form.Office) {
                    let newAddedManager = [];
                    if (this.user.Managers) {
                        newAddedManager = this.user.Managers;
                        this.form.Number = this.$parseNumber(this.form.Number);
                        
                        const duplicateManager = newAddedManager.find(
                            (mg) =>
                            (mg.MgrID !== this.form.MgrID) &&
                            ((this.form.Email && mg.Email === this.form.Email) || 
                            (this.form.Number && mg.Number === this.form.Number))
                        );

                        if (duplicateManager) {
                            let identifier = '';
                            if (this.form.Email && duplicateManager.Email === this.form.Email) {
                                identifier = `${this.form.Email}`;
                            } else if (this.form.Number && duplicateManager.Number === this.form.Number) {
                                identifier = `${this.form.Number}`;
                            }
                            alert(`Manager already exists for ${identifier}.`);
                            this.form.First = '';
                            this.form.Last = '';
                            this.form.Email = '';
                            this.form.Number = '';
                            this.form.Office = '';
                            this.form.MgrID = '';
                            return;
                        }
                        
                        if (this.form.MgrID) {
                            for(let mg of newAddedManager) {
                                if (this.form.MgrID == mg.MgrID) {
                                    mg.First = this.form.First;
                                    mg.Last = this.form.Last;
                                    mg.Email = this.form.Email;
                                    mg.Number = this.form.Number;
                                    mg.Office = this.form.Office;
                                    break;
                                }
                            }
                        }else {
                            newAddedManager.push({
                            First:this.form.First,
                            Last:this.form.Last,
                            Email:this.form.Email,
                            Number:this.form.Number,
                            Office:this.form.Office,
                            MgrID:this.getUniqueManagerID()
                        });
                        }
                    }else {
                        newAddedManager.push({
                            First:this.form.First,
                            Last:this.form.Last,
                            Email:this.form.Email,
                            Number:this.form.Number,
                            Office:this.form.Office,
                            MgrID:this.getUniqueManagerID()
                        });
                    }
                    this.form.First = '';
                    this.form.Last = '';
                    this.form.Email = '';
                    this.form.Number = '';
                    this.form.Office = '';
                    this.form.MgrID = '';
                    db.doc(`Users/${this.user.id}`).update({ Managers: newAddedManager});
                    this.showManagerLoader = true;
                    setTimeout(() => {
                        this.showManagerLoader = false;
                        this.isDisableOffice =false;
                    }, 1000);
                    this.$bvModal.hide('AddManagerModal');
                // }
                // else {
                //     alert("An Office Name is required.");
                // }
            },
            AddManagerModalEvent() {
                this.form.First = '';
                this.form.Last = '';
                this.form.Email = '';
                this.form.Number = '';
                this.form.Office = '';
                this.form.MgrID = '';
                this.isDisableOffice = false;
                this.$bvModal.show('AddManagerModal');
            },
            getUniqueManagerID() {
                let did = (Math.floor(Math.random()*(100000-1+1)+1));
                let um = this.user.Managers.find(m => m.MgrID == did)
                if (um) {
                    this.getUniqueManagerID();
                }
                return did;
            },
            getManagerWiseProspect(sManager) {
                //eslint-disable-next-line
                console.log(sManager);
                let managerProps = [];
                // for(let pro of this.prospects) {
                //     if (pro.hasOwnProperty('SentToManager')) {
                //         let sentManager = pro.SentToManager;
                //         let sm = sentManager.find(sm => sm.Manager == sManager.MgrID);
                //         if (sm) {
                //             managerProps.push(pro);
                //         }
                //     }
                // }
                return managerProps;
            },
            async singleManagerProspectClick(task) {
                let convo = this.$store.state.firebase.convos.find(convo => convo.ClientNumber == task.Number);
                
                if (!convo) {
					convo = await db.collection('Conversations').add({
						ClientNumber: task.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: task.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id);
                if (this.emails.length) {
                    let mid = this.getEmailConvoID(task.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
                    // this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(task.id));
                }
				this.$emit('open','prosp');
            },
            editManagerDetail(md) {
                this.$bvModal.show('AddManagerModal');
                this.$refs.managerForm.scrollIntoView({ block: 'end', scrollBehavior: 'smooth' });
                this.form.First = md.First;
                this.form.Last = md.Last;
                this.form.Email = md.Email;
                this.form.Number = this.$parseNumber(md.Number);
                // this.form.Office = md.Office;
                this.form.MgrID = md.MgrID
                // this.isDisableOffice =true;
            },
            removeManger(md) {
				if (confirm("Are you sure you want to delete this manager?")) {
                    let i=0;
                    let mangers = this.user.Managers
					for (let m of mangers) {
						if (md.MgrID == m.MgrID) {
							mangers.splice(i,1)
						}
						i++;
                    }
					db.doc(`Users/${this.user.id}`).update({Managers:mangers});
				}
			},
            getFileName() {
                return  this.user.Company+'-'+this.$parsePlainDate(new Date(this.form.date_s).getTime())+'-'+this.$parsePlainDate(new Date(this.form.date_e).getTime())+'-sent-to-manager.csv';
            },
            getCSVData() {
                let csvDataJson = this.prospectMangerCSVList;
                if (this.downloadCount == 0) {
                    this.downloadCount = this.downloadCount+1;
                    csvDataJson.sort((a, b) => b.SentOn - a.SentOn);
                    csvDataJson.forEach(element => {
                        let so = this.$parsePlainDate(element.SentOn);
                        // element.SentOn = so;
                        element['DuplicateSentOn'] = so;
                        let ro = this.$parsePlainDate(element.ReviewedOn);
                        // element.ReviewedOn = ro;
                        element['DuplicateReviewedOn'] = ro;
                    })
                }
                return csvDataJson;
            }
		},
		data() {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
			return {
                form: {
                    date_s:firstDay,
                    date_e:new Date(),
					s_date: firstDay,
                    e_date: new Date(),
                    First: '',
                    Last:'',
                    Email:'',
                    Number:'',
                    Office:'',
                    MgrID:''
				},
                isDisableOffice:false,
                fields: [
                    'Action',
                    {'key':'First',sortable: true}, 
                    {'key':'Last',sortable: true}, 
                    {'key':'Email',sortable: true},
                    {'key':'Number',sortable: true},
                    {'key':'Office',sortable: true},
                    {'key':'ProspectsSent',sortable: true},
                    {'key':'ProspectsReviewed',sortable: true},
                    'Prospect'],
                totalSentProspect:0,
                totalReviewdProspect:0,
                managerFields:['DuplicateSentOn','First','Last','Email','Number','Zip','Source','Notes','Office','MName','MEmail','MNumber','DuplicateReviewedOn','Rating','MNote'],
                managerLabels:{
                    DuplicateSentOn: 'Date Sent to Manager',
                    First: 'Prospect First Name',
                    Last: 'Prospect Last Name',
                    Email:'Prospect Email',
                    Number: 'Prospect Phone Number',
                    Zip:'Prospect Postal Code',
                    Source:'Prospect Source',
                    Notes:'Recruiter Notes',
                    MName:'Manager Name',
                    MEmail:'Manager Email',
                    MNumber:'Manager Phone Number',
                    DuplicateReviewedOn:'Date of Manager Review',
                    Rating:'Rating from Manager',
                    MNote:'Manager Notes'
                    
                },
                prospectMangerCSVList:[],
                downloadCount:0,
                showManagerLoader:false,
			}
        }
        
        // {key:'Twilio',label: 'taTEXT Number',}
	}
</script>

<style scoped>
	.btn-group button.btn.btn-outline-primary{       
        background: #042b79;
        color: #fff;
        border-color: #042b79;
    }
    .date_picker_add b-form-datepicker{
        top:160px;
    }
    .page-wrapper{
        height: 100vh;overflow-x: hidden;overflow-y: auto;
    }
    .submit-form-btn.btn-group > button {
    padding: 5px 30px;
}
.submit-form-btn.btn-group {
    /* max-width: 100px; */
    text-align: center;
    /* margin-right: 0; */
    width: 100%;
    /* text-align: end; */
    display: inline-block;
    padding: 0 !important;
    margin-top: 10px;
    margin-bottom: 10px;
}
.custom-form{
    margin-bottom: 30px;
    background: rgb(242 242 242 / 30%);
    padding: 20px;
    box-shadow: 0px 0px 4px 0px #d3cfcf;
    border-radius: 3px;
    /* border: 1px solid #ccc; */
    width: 90%;
}
.bv-no-focus-ring input {
    padding: 11px 15px;
    height: 100%;
}
form.row.manager-form {
    margin: 0px -5px !important;
}
form.row.manager-form > div{
    padding: 0px 5px !important;
}
.form-title{
    width: 100%;text-align: center;display: inline-block;
}
.showProsBtn{
    font-size: 13px;
}
</style>